import Collapse from '@/components/Collapse';
import Toggle from '@/directives/Toggle';

const Plugin = {
    install(Vue, options = {}) {
        /**
         * Makes sure that plugin can be installed only once
         */
        if (this.installed) {
            return;
        }

        const defaultComponentName = 'Collapse';
        const defaultDirectiveName = 'toggle';

        this.installed = true;
        this.componentName = options.componentName || defaultComponentName;
        this.directiveName = options.directiveName || defaultDirectiveName;

        /**
         * Sets custom component/directive name (if provided)
         */
        Vue.component(this.componentName, Collapse);
        Vue.directive(this.directiveName, Toggle);
    },
};

export default Plugin;
